import React, { useRef } from 'react';

const Footer = ({ onOpenAuthModal }) => {
  const clickCount = useRef(0);
  const clickTimer = useRef(null);

  const handleLogoClick = () => {
    clickCount.current += 1;
    clearTimeout(clickTimer.current);
    if (clickCount.current >= 3) { clickCount.current = 0; if (onOpenAuthModal) onOpenAuthModal(); }
    else { clickTimer.current = setTimeout(() => { clickCount.current = 0; }, 800); }
  };

  return (
    <footer className="border-t border-[#E1E8F0]" data-testid="footer">
      <div className="container-institutional py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-2 cursor-pointer select-none" onClick={handleLogoClick} data-testid="footer-logo">
            <img src="/logo-urbanik.png" alt="URBANIK" className="h-8 w-auto" />
          </div>
          <p className="text-[#94A3B8] text-xs">
            Conçu par{' '}
            <a href="https://www.relaisit.com" target="_blank" rel="noopener noreferrer" className="text-[#1E3A5F] font-semibold hover:text-[#F5A623] transition-colors" data-testid="relais-it-link">
              Relais IT
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
